import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vconsole from 'vconsole'
import '@/utils/rem.js'
import mitt from 'mitt'

const Mit = mitt()
// new Vconsole()
const app = createApp(App)
declare module 'vue' {
    export interface ComponentCustomProperties {
      $Bus: typeof Mit
    }
  }
  //vue3挂载全局API
  app.config.globalProperties.$Bus = Mit
app.use(store).use(router)
app.mount('#app')
